<div class="container">
  <div class="data-icon" [style.background-color]="iconBackgroundColor"><mat-icon [style.color]="iconColor">{{ iconName }}</mat-icon></div>
  <div class="data-text-conatiner">
    <div class="data-number" [style.color]="dataColor">{{ isLoading ? 'loading...' : data }}</div>
    <div class="data-text">{{ title }}</div>
  </div>
</div>
